import { put } from 'redux-saga/effects'

import Internal from 'common/modules/internal'

function* watchGetPaymentsSuccess(data) {
    yield put(Internal.creators.sendMessage({
        payload: {
            target: '*',
            ...data,
        },
    }))
}

function* watchGetPaymentsError(data) {
    yield put(Internal.creators.sendMessage({
        payload: {
            target: '*',
            ...data,
        },
    }))
}

export {
    watchGetPaymentsSuccess,
    watchGetPaymentsError,
}
